import { render, staticRenderFns } from "./search.vue?vue&type=template&id=63364a5c&scoped=true"
import script from "./search.vue?vue&type=script&lang=js"
export * from "./search.vue?vue&type=script&lang=js"
import style0 from "./search.vue?vue&type=style&index=0&id=63364a5c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63364a5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/crmeb/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63364a5c')) {
      api.createRecord('63364a5c', component.options)
    } else {
      api.reload('63364a5c', component.options)
    }
    module.hot.accept("./search.vue?vue&type=template&id=63364a5c&scoped=true", function () {
      api.rerender('63364a5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/navBars/breadcrumb/search.vue"
export default component.exports